import React from 'react';
import { StyleSheet, View, Text, Pressable } from 'react-native';
import { LeftArrowIcon, PlusIcon } from '../Icons';
import { colors } from '../Shared';

interface Props {
    onBack?: () => void;
    onCreate?: () => void;
    title: string;
}
export default function SettingsHeader({ onBack, onCreate, title }: Props) {

    return <View style={styles.container}>
        {onBack && <Pressable onPress={onBack}>
            <LeftArrowIcon />
        </Pressable>}

        <Text style={styles.title}>{ title }</Text>

        {onCreate && <Pressable onPress={onCreate} style={{ marginRight: 5 }}>
            <PlusIcon />
        </Pressable>}
    </View>
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        height: 50,
        backgroundColor: colors.bg.light,
        alignItems: 'center',
        padding: 5,
        margin: 5,
        borderRadius: 5,
    },
    title: {
        flex: 1, marginLeft: 5,
        fontWeight: '400',
        fontSize: 16
    }
})